var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/icons/Edit.tsx"; // This file was auto-generated using scripts/generate-icons.js
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Icon generated from edit.svg
 */
export default function EditIcon(props) {
  return _jsxDEV("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    "aria-hidden": "true",
    viewBox: "0 0 16 16",
    "data-component": "EditIcon",
    ...props,
    children: _jsxDEV("g", {
      "fill-rule": "evenodd",
      children: [_jsxDEV("path", {
        fill: "none",
        d: "M0 0h16v16H0z"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 9
      }, this), _jsxDEV("path", {
        fill: "currentColor",
        d: "M14.613.21a1 1 0 0 0-1.32.083l-1 1-.083.094a1 1 0 0 0 .083 1.32l1 1 .094.083a1 1 0 0 0 1.32-.083l1-1 .083-.094a1 1 0 0 0-.083-1.32l-1-1zm-3 3a1 1 0 0 0-1.32.083l-9 9-.072.08a1 1 0 0 0-.115.18l-1 2-.044.1c-.316.827.559 1.655 1.385 1.241l2-1 .093-.053a1 1 0 0 0 .167-.134l9-9 .083-.094a1 1 0 0 0-.083-1.32l-1-1z"
      }, void 0, false, {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 9
      }, this)]
    }, void 0, true, {
      fileName: _jsxFileName,
      lineNumber: 20,
      columnNumber: 7
    }, this)
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 11,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=Edit.js.map